"use strict"

import React, { useState, useEffect, useContext } from "react"

import { AppSettingConfigContext, PageTitle } from "../../../config/AppSettingsConfigProvider"
import FileActionRow from "./FileActionRow"
import FileUploadSearchFilter from "./FileUploadSearchFilter"
import FileUploadTable from "./FileUploadTable"

export const table_name = "view_files"

export default function FileUploadScreen({
  selections,
  selected_file_id,
  filterEditorOnSearch,
  tableReload,
  setFileSelection,
  intl,
}) {
  const app_config = useContext(AppSettingConfigContext)
  const [permissions, setPermissions] = useState([])

  useEffect(() => {
    if (app_config?.config?.user && app_config.config.user?.permissions) {
      setPermissions(app_config.config.user.permissions)
    }
  }, [app_config?.config?.user])

  return (
    <div className={"full-height"}>
      <div className={"content-block full-height-min"}>
        <PageTitle glyph={"file-o"} id={"administration.file-uploads"} description={"File Uploads"} />
        <hr />
        <div id={"error-banner"} />
        <FileUploadSearchFilter filterEditorOnSearch={filterEditorOnSearch} intl={intl} />
        <FileUploadTable
          selected_file_id={selected_file_id}
          setFileSelection={setFileSelection}
          user_can_edit={permissions.includes("edit_files")}
          tableReload={tableReload}
          intl={intl}
        />
        <FileActionRow
          selections={selections}
          tableReload={tableReload}
          user_can_edit={permissions.includes("edit_files")}
          intl={intl}
        />
      </div>
    </div>
  )
}
